import type {
  SettlementCandidate,
  SettlementVerificationEnqueueResult,
} from '@/types'

const SETTLEMENT_VERIFICATION_SKIP_REASONS = new Set([
  'already_verified',
  'duplicate_settlement_already_verified',
  'missing_tx_hash',
  'no_settlement_record',
  'record_not_found',
])

export function countSettlementExecutionResults(
  results: SettlementCandidate[]
): { queued: number; failed: number; skipped: number } {
  const queued = results.filter(result => result.queued).length
  const skipped = results.filter(result => !result.queued && !result.eligible).length
  return {
    queued,
    skipped,
    failed: results.length - queued - skipped,
  }
}

export function countSettlementVerificationResults(
  results: SettlementVerificationEnqueueResult[]
): { queued: number; failed: number; skipped: number } {
  const queued = results.filter(result => result.queued).length
  const skipped = results.filter(result =>
    !result.queued
    && SETTLEMENT_VERIFICATION_SKIP_REASONS.has(result.reason ?? '')
  ).length
  return {
    queued,
    skipped,
    failed: results.length - queued - skipped,
  }
}
